<template>
  <div class="appointDetail">
    <div class="allHeader">
      <div class="header-H">
        <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
        <span class="addInfo">预约详情</span>
      </div>
      <div class="projectName">
        <div class="nameFlex">
          <!-- // 0待完成1已完成2已取消 -->
          <div class="detailName">{{ form.projectName }}</div>
          <div class="schedule" v-if="form.operationStatus == 2">已完成</div>
          <div class="cancel" v-if="form.operationStatus == 1">已取消</div>
          <div class="toBeFinish" v-if="form.operationStatus == 3">待完成</div>
        </div>
        <div class="nextImg">
          <div>
            <div class="user_name">
              <van-icon name="user-circle-o" color="#fff" /> <span class="schedule_name">{{ form.customerName }}</span>
            </div>
            <div class="user_name">
              <van-icon name="clock-o" color="#fff" /><span class="schedule_name">{{ form.appointmentTime }}</span>
            </div>
          </div>
          <div class="vipImg">
            <img v-if="form.appointStatus == 'VIP'" src="../../assets/img/vipVisit.png" alt="">
            <img v-if="form.appointStatus == '初诊'" src="../../assets/img/visit.png" alt="">
            <img v-if="form.appointStatus == '复诊'" src="../../assets/img/secondVisit.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <van-cell-group v-if="form">
        <van-cell title="预约号" :value="form.appointmentId" />
        <!-- <van-cell title="联系方式" :value="form.mobile" /> -->
        <van-cell v-if="userStatus == 0" title="联系方式" :value="form.mobile" />
        <span v-if="form.mobile">
          <van-cell v-if="userStatus == 1" title="联系方式"
            :value="form.mobile.replace(form.mobile.substr(0, 7), '*******')" />
        </span>
        <!-- <van-cell title="初/复诊" :value="form.appointStatus" /> -->
        <van-cell title="仪器使用时间">
          <div v-if="form.instrumentTime" class="showOverTooltip">
            <div v-for="(item, index) in form.instrumentTime.split(',')" :key="index">
              <span>{{ item }}</span>
            </div>
          </div>
        </van-cell>
        <van-cell title="操作人" :value="form.doctorName" />
        <van-cell title="客户姓名" :value="form.customerName" />
        <van-cell title="备注" :value="form.remark" />
        <!-- <van-cell title="预约提交时间" :value="form.createTime" /> -->
        <van-cell title="完成时间" :value="form.completionTime" v-if="form.operationStatus == 2" />
        <van-cell title="取消时间" :value="form.completionTime" v-if="form.operationStatus == 1" />
      </van-cell-group>
      <div class="addProject" @click="copyProject(form)" v-if="form.projectType != '' && form.projectType != null">复制项目
      </div>

      <div class="concat" v-show="flag">
        <div class="contactClients" @click="callPhone(form.mobile)">联系客户</div>
        <div class="cancelAppointment" v-if="form.operationStatus == 3" @click="sureFinish(form, 1)">取消预约</div>
        <!-- <div class="cancelAppointment" v-if="form.operationStatus==3" @click="sureFinish(form,2)">确认完成</div> -->
        <div class="cancelAppointment" v-if="form.operationStatus == 3" @click="handEdit(form)">编辑</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  updateAppointmentStatusById
} from "@/axios/api";
import {
  Toast
} from 'vant';
export default {
  data() {
    return {
      form: {},
      userStatus: '',
      flag: true
    }
  },
  created() {
    this.form = this.$route.query
    // console.log(this.$route.query)
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    console.log('this.userStatus')
    console.log(this.userStatus)
    if (this.userStatus == 1) {
      this.flag = false
    } else if (this.userStatus == 0) {
      this.flag = true
    }
  },
  methods: {
    // 添加预约返回首页
    returnIndex() {
      this.$router.push("/allAppointments");
    },
    // 联系客户
    callPhone(phoneNumber) {
      console.log(phoneNumber)
      window.location.href = 'tel://' + phoneNumber
    },
    // 取消预约
    sureFinish(row, val) {
      // 2-确认完成,1-取消
      console.log(row)
      console.log(val)
      let data = {
        appointmentId: row.appointmentId,
        operationStatus: val,
        projectType: row.projectType
      }
      updateAppointmentStatusById(data)
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            Toast.success('状态修改成功');
            this.$router.push("/allAppointments");
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑当条信息
    handEdit(row) {
      console.log(row)
      this.$router.push({
        name: "editAppointment",
        query: row,
      });
    },
    copyProject(row) {
      this.$router.push({
        name: "copyDetailAppointment",
        query: row,
      });
    }
  },

}

</script>
<style scoped>
@import "../../assets/css/appointDetail.css";

.vanIcon {
  position: absolute;
  left: 1.3rem;
}

.concat {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-bottom: 0.3rem;
}

.concat div {
  width: 4.5rem;
  height: 1.56rem;
  background: #ffffff;
  border-radius: 0.81rem;
  border: 1px solid #0164a8;
  font-size: 0.75rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0164a8;
  text-align: center;
  line-height: 1.56rem;
  margin-left: 0.3rem;
}

.vipImg img {
  width: 2.5rem;
  margin-top: 0.6rem;
}

.nextImg {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.addProject {
  width: 100%;
  height: 2.5rem;
  margin: 0.5rem auto;
  background: linear-gradient(160deg, #1fdbcf 0%, #1bcaca 12%, #0164a8 100%);
  border-radius: 6px;
  text-align: center;
  line-height: 2.5rem;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 0.38rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/mineDetail.vue